<template>
  <v-card class="hero" :height="windowSize.y" v-resize="onResize">
    <div class="title">
      <h1 class="text-h2 white--text mb-12">
        Cobb Egg Picker
      </h1>
      <v-btn color="black"
        x-large
        class="white--text elevation-3"
        @click="signIn()">
        Sign In
      </v-btn>
      <v-card
        v-if="noAccess"
        class="elevation-2">
        <h3 class="mt-4 error white--text pa-5">
          Access Denied
        </h3>
      </v-card>
    </div>
    <v-overlay :value="isBusy">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      isBusy: false,
      noAccess: false,
      windowSize: {x: 0,y: 0}
    };
  },
  mounted () {
    this.onResize();
  },
  methods: {
    ...mapActions(['storeSignIn']),
    async signIn() {
      this.isBusy = true;
      try {
        this.noAccess = false;
        await this.storeSignIn();
      } catch (error) {
        console.log(error); // eslint-disable-line no-console
        this.noAccess = true;
      }
      this.isBusy = false;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
  }
};
</script>

<style scoped>
.hero {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8)),
    url("../assets/img/favicon-742x742.png") no-repeat center center fixed;
  /* background-size: cover; */
 }
.title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.hero h1 {
  text-shadow: 5px 3px 5px black;
}
</style>